<div class="loader" [hidden]="status != STATUS_LOADING">
  <div class="dimmed">
    <div class="dimmed_box"></div>
    <div class="dimmed_table_box"></div>
    <div class="dimmed_table_box"></div>
    <div class="dimmed_table_box"></div>
    <div class="dimmed_table_box"></div>
    <div class="dimmed_table_box"></div>
    <div class="dimmed_table_box"></div>
  </div>
</div>

    <div class="app-wrapper" *ngIf="status == STATUS_DONE">
      <nav class="tab_navigation">
        <!-- &nbsp; -->
      </nav>
      <section class="main-content library-section">
        <div class="app-main">
          <library-search-main></library-search-main>
          <library-results
            [params]="params"
          ></library-results>
        </div>
      </section>
    </div>
  <core-helpers-box-http-error
      *ngIf="status == STATUS_NOT_ALLOWED"
      [code]="403"
      [message]="'Not allowed.'"
  ></core-helpers-box-http-error>

  <core-helpers-box-http-error
      *ngIf="status == STATUS_NOT_FOUND"
      [code]="404"
      [message]="'Not found.'"
  ></core-helpers-box-http-error>

  <core-helpers-box-http-error
      *ngIf="status == STATUS_ERROR"
      [code]="500"
      [message]="'Error.'"
  ></core-helpers-box-http-error>
